export const requestAutoCompleteItemsQuery = () => `
    query publicAutoCompleteItems {
        publicAutoCompleteItems {
            source
            exchangeMic
            symbol
            country
            name
            tickerType
            isActive
            hasEodSeries
            hasIntradaySeries
            hasVolumeSeries
            hasYieldSeries
            eodStorage
            tickStorage
            eodSeriesStartDate
        }
    }
`;